import { Component } from '@angular/core';
import { ExpenditureService } from '../expenditure.service';
import { Expenditure } from '../expenditure';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'app-expenditure-edit',
  templateUrl: 'edit.component.html',
})
export class ExpenditureEditComponent {
  /**
   * Details of the expenditure being edited.
   */
  public expenditure: Expenditure;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {ExpenditureService} expenditureService
   * @param {NotificationService} notificationService
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  constructor(
    private expenditureService: ExpenditureService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.expenditureService.loading.subscribe(
      result => (this.isLoading = result),
    );
    this.route.params.subscribe(params => this.loadExpenditure(params.id));
  }

  /**
   * Perform the edit action which send the edited expenditure to the backend.
   */
  public edit() {
    const editExpenditure = this.expenditureService
      .updateExpenditure(this.expenditure.id, this.expenditure)
      .subscribe(
        (result: Expenditure) => {
          this.notificationService.success(
            `Expenditure Updated`,
            `The expenditure ${
              result.name
            } been updated with the specified changes.`,
            5,
          );
          this.expenditure = new Expenditure();
          editExpenditure.unsubscribe();
          this.router.navigate(['/expenditures']);
        },
        err => {
          this.notificationService.error(
            `Expenditure Not Found`,
            err.error.message,
            10,
          );
          this.router.navigate(['/expenditures']);
        },
      );
  }

  /**
   * Loads the requested expenditure so we can display it and let the user edit the fields.
   *
   * @param {string} id
   */
  private loadExpenditure(id: string) {
    this.expenditureService.findExpenditure(id).subscribe(
      result => {
        this.expenditure = result;
      },
      err => {
        this.notificationService.error(
          `Expenditure Not Found`,
          err.error.message,
          10,
        );
        this.router.navigate(['/expenditures']);
      },
    );
  }
}
